<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div class="d-flex align-items-center gap-2 flex-grow-1">
      <div *ngIf="isEstimated; else annualMinimumLabel" i18n class="detail-label">Estimated Annual Minimum</div>
      <img
        [ngbTooltip]="tooltip"
        class="cursor-pointer"
        src="assets/icons/grey/CircleQuestion.svg"
        alt=""
        [style.height.rem]="1.5"
        [style.width.rem]="1.5" />
    </div>
    <div i18n class="detail-value">{{ annualMinimum | currency }}</div>
  </div>
</div>

<ng-template #annualMinimumLabel>
  <div i18n class="detail-label">Annual Minimum</div>
</ng-template>

<ng-template #tooltip>
  <div *ngIf="isEstimated; else defaultTooltip" class="tooltip-text" i18n>
    The minimum total payment amount required for the year, based on estimates from the previous year for the variable
    benefit account balance(s) and the selected minimum age(s)
  </div>
  <ng-template #defaultTooltip>
    <div class="tooltip-text">{{ tooltipText }}</div>
  </ng-template>
</ng-template>
